import React from "react"
import { FormattedMessage, IntlProvider } from "react-intl"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import Paths from "../../views/pages/landing/Paths"
import configFront from "../../config-front"

import messages_en from "../../assets/data/locales/en.json"
import messages_de from "../../assets/data/locales/de.json"
import messages_fr from "../../assets/data/locales/fr.json"
import messages_pt from "../../assets/data/locales/pt.json"
import messages_es from "../../assets/data/locales/es.json"
import messages_ca from "../../assets/data/locales/ca.json"
import { SUPPORTED_LOCALES } from "../i18n/localeConfig"

// Función para procesar mensajes y reemplazar placeholders con valores de configuración
const processMessages = (messages) => {
  const processedMessages = { ...messages }
  const companyName = configFront.commercialName || 'Xperitt'
  
  // Reemplazar {companyName} en todos los mensajes
  Object.keys(processedMessages).forEach(key => {
    if (typeof processedMessages[key] === 'string') {
      processedMessages[key] = processedMessages[key].replace(/{companyName}/g, companyName)
    }
  })
  
  return processedMessages
}

// Procesar todos los mensajes una vez al cargar
const menu_messages = {
  en: processMessages(messages_en),
  de: processMessages(messages_de),
  fr: processMessages(messages_fr),
  pt: processMessages(messages_pt),
  es: processMessages(messages_es),
  ca: processMessages(messages_ca)
}

// Idioma por defecto configurable desde config-front.js, con fallback a 'es'
const DEFAULT_LOCALE = SUPPORTED_LOCALES.includes(configFront.defaultLocale)
  ? configFront.defaultLocale
  : "es"

const resolveLocale = (candidate) => {
  if (typeof candidate === "string" && candidate.length >= 2) {
    const short = candidate.substring(0, 2)
    if (SUPPORTED_LOCALES.includes(short)) {
      return short
    }
  }
  return DEFAULT_LOCALE
}

const Context = React.createContext()

class IntlProviderWrapper extends React.Component {
  state = {
    locale: DEFAULT_LOCALE,
    messages: menu_messages[DEFAULT_LOCALE],
    modal: true,
  }

  setCookie = () => {
    const localeToSave = resolveLocale(this.state.locale || navigator.language)
    localStorage.setItem("locale", localeToSave)
    this.toggleModal()
  }

  toggleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }))
  }

  setLocale(newLocale){
    this.setState({locale: newLocale, messages: menu_messages[newLocale]});
  }

  componentWillMount(){
    try{
      const savedLocale = localStorage.getItem('locale');
      if(savedLocale !== null && savedLocale !== undefined){
        const newLocale = resolveLocale(savedLocale);
        this.setState({modal: false, locale: newLocale, messages: menu_messages[newLocale]});
      } else {
        // Sin locale guardado: usar el idioma del navegador si está soportado,
        // si no, caer al defaultLocale configurado en config-front.js
        const newLocale = resolveLocale(navigator.language);
        this.setState({locale: newLocale, messages: menu_messages[newLocale]});
      }
    } catch (err){
      console.log(err);
    }
  }

  render() {
    const { children } = this.props
    const { locale, messages } = this.state
    return (
      <Context.Provider
        value={{
          state: this.state,
          switchLanguage: (language) => {
            const newLocale = resolveLocale(language)
            try {
              localStorage.setItem("locale", newLocale)
            } catch (err) {
              console.log(err)
            }
            this.setState({
              locale: newLocale,
              messages: menu_messages[newLocale],
            })
          },
        }}
      >
        <IntlProvider
          key={locale}
          locale={locale}
          messages={messages}
          defaultLocale={"us"}
        >
          <Modal
            isOpen={this.state.modal}
            toggle={this.toggleModal}
            className="modal-dialog-centered"
          >
            <ModalHeader toggle={this.toggleModal}>
              <FormattedMessage id="useCookiesHeader"/> 
            </ModalHeader>
            <ModalBody className="modal-dialog-centered">
              <FormattedMessage id="useCookiesBody"/>
            </ModalBody>
            <ModalFooter>
              <Button outline color="primary" onClick={this.toggleModal}
              href={Paths.cookies}>
                <FormattedMessage id="moreInfo"/>
              </Button>
              <Button color="primary" 
               onClick={this.setCookie}
              
              >
                <FormattedMessage id="accept"/>
              </Button>{" "}
            </ModalFooter>
          </Modal>
          {children}
        </IntlProvider>
      </Context.Provider>
    )
  }
}

export { IntlProviderWrapper, Context as IntlContext, SUPPORTED_LOCALES, resolveLocale }
